export default {
  title: {
    en: 'Choose friends to invite',
  },
  cancel: {
    en: 'Cancel',
  },
  send: {
    en: 'Send invitations',
  },
  searchContacts: {
    en: 'Search in {count, plural, one {# contact} other {# contacts}}',
  },
  noContacts: {
    en: 'Your contacts list is empty',
  },
  checkAll: {
    en: 'Check All',
  },
  uncheckAll: {
    en: 'Uncheck All',
  },
  emailsWereSent: {
    en: 'Emails were sent',
  },
  ok: {
    en: 'OK',
  },
}
